import { Box, Button, Image, Paragraph, Strong, Text } from '@customerio/pluma-components/react';
import bigqueryLogo from '@/assets/images/integrations/bigquery.svg';
import googleCloudStorageLogo from '@/assets/images/integrations/google-cloud-storage.svg';
import { ConnectorLanding } from './components/connector-landing';
import * as styles from './components/connector-landing.css';
import type { WarehouseLandingPageProps } from './types';

export default function BigQueryPage({ workspaceId, sync, showPremiumLabel }: WarehouseLandingPageProps) {
  return (
    <ConnectorLanding
      workspaceId={workspaceId}
      sync={sync}
      showPremiumLabel={showPremiumLabel}
      logoSrc={bigqueryLogo}
      title="Google BigQuery"
      blurb="BigQuery is a serverless, highly scalable, and cost-effective cloud data warehouse designed to help make informed decisions quickly."
      ingestStep={
        <>
          <Paragraph size="xs" color="subtle" mt="050" mb="200">
            There are many approaches to this, but here's one example using a Cloud Function to move data from a GCS
            bucket to BigQuery.
          </Paragraph>

          <div className={styles.exampleRow}>
            <Box flex={1}>
              <Image
                src={googleCloudStorageLogo}
                alt=""
                display="inline-block"
                verticalAlign="middle"
                size="icon-v2-lg"
              />
              <Strong>GCS Bucket</Strong>
              <Text mx="100" color="subtle">
                →
              </Text>
              <Image src={bigqueryLogo} alt="" display="inline-block" verticalAlign="middle" size="icon-v2-lg" />
              <Strong>BigQuery</Strong>
            </Box>

            <Button
              size="sm"
              variant="secondary"
              icon="exit"
              iconPosition="trailing"
              href="https://docs.customer.io/data-warehouse-sync#faq"
              isExternal={true}
            >
              View example
            </Button>
          </div>
        </>
      }
    />
  );
}
